export default __webpack_public_path__ + "static/media/img7.0b843d69.svg";